var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.structureLoadingState === "done"
        ? _c(
            "div",
            [
              _c("public-courseware-structural-element", {
                attrs: {
                  canVisit: true,
                  "structural-element": _vm.selected,
                  "ordered-structural-elements": _vm.orderedStructuralElements,
                },
                on: {
                  select: _vm.selectStructuralElement,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.structureLoadingState === "loading"
        ? _c("studip-progress-indicator", {
            staticClass: "loading-indicator-content",
            attrs: {
              description: _vm.$gettext("Lade Lernmaterial..."),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.structureLoadingState === "error"
        ? _c("courseware-companion-box", {
            attrs: {
              mood: "sad",
              msgCompanion: _vm.loadingErrorMessage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.wrongPassword
        ? _c("courseware-companion-box", {
            attrs: {
              mood: "sad",
              msgCompanion: _vm.passwordMessage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAuthenticated
        ? _c(
            "form",
            {
              staticClass: "default",
              on: {
                submit: function submit($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "label",
                [
                  _c("translate", [_vm._v("Passwort")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    attrs: {
                      type: "password",
                    },
                    domProps: {
                      value: _vm.password,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: _vm.submitPassword,
                  },
                },
                [_c("translate", [_vm._v("Absenden")])],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }